import jQuery from 'jquery';
import { browserHistory } from 'react-router';

const ROOT_URL = 'https://remeha-nl-api.bagaar.be';

const headers = {
  'Content-Type': 'application/json',
  Accept: 'application/json',
};

function setHeaders(name, value) {
  headers[name] = value;
}

function getHeaders() {
  return headers;
}

function call(url, method, data, retry, customHeaders = null, isXml = false) {
  const body = JSON.stringify(data);
  let fetchObject = null;
  let fetchHeaders = headers;

  if (customHeaders) {
    fetchHeaders = {
      ...headers,
      ...customHeaders,
    };
  }

  if (method === 'GET') {
    fetchObject = {
      method,
      headers: fetchHeaders,
    };
  } else {
    fetchObject = {
      method,
      body,
      headers: fetchHeaders,
    };
  }

  return fetch(`${ROOT_URL}${url}`, fetchObject).then((response) => { // eslint-disable-line
    if (response && response.status === 404) {
      return {
        json: null,
        response,
      };
    } else if (response && response.status === 503) {
      browserHistory.push('/maintenance');

      return {
        json: null,
        response,
      };
    } else if (response && response.status !== 500) {
      if (isXml) {
        return response.text();
      }
      return response.json().then((json) => {
        return {
          json,
          response,
        };
      }).catch(() => {
        return {
          json: null,
          response,
        };
      });
    }

    return {
      json: null,
      response,
    };
  });
}

function get(url, data, retry = false, customHeaders = null) {
  let constructedUrl = url;

  if (data) {
    constructedUrl = `${constructedUrl}?${jQuery.param(data)}`;
  }

  return call(constructedUrl, 'GET', null, false, customHeaders);
}

function getXML(url, data, retry = false, customHeaders = null) {
  let constructedUrl = url;

  if (data) {
    constructedUrl = `${constructedUrl}?${jQuery.param(data)}`;
  }

  return call(constructedUrl, 'GET', null, false, customHeaders, true);
}

function post(url, data, retry = false, customHeaders = null) {
  return call(url, 'POST', data, retry, customHeaders);
}

function put(url, data) {
  return call(url, 'PUT', data);
}

function patch(url, data) {
  return call(url, 'PATCH', data);
}

function del(url, data) {
  return call(url, 'DELETE', data);
}

function downloadFile(url) {
  const a = document.createElement('a');
  a.style.display = 'none';
  document.body.appendChild(a);
  a.href = url;
  a.click();
  document.body.removeChild(a);
}

function getRootUrl() {
  return ROOT_URL;
}

module.exports = {
  delete: del,
  get,
  getXML,
  getRootUrl,
  downloadFile,
  getHeaders,
  patch,
  post,
  put,
  ROOT_URL,
  setHeaders,
};



// WEBPACK FOOTER //
// ./js/services/api.js